import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import AddingAreaPincode from '../Area&PincodeMasterData/addAreaPincode-modal';
 
interface AddAreaPincodeMasterProps {
  showAreaPincodeDialog: boolean;
  hideAreaPincodeDialog: () => void;
  handleAddSuccess: () => void;
}
 
const AddAreaPincodeMaster: React.FC<AddAreaPincodeMasterProps> = ({ showAreaPincodeDialog, hideAreaPincodeDialog, handleAddSuccess }) => {
  return (
    <Dialog
      visible={showAreaPincodeDialog}
      className="quickview w-50"
      breakpoints={{ '960px': '75vw', '641px': '90vw' }}
      modal
      onHide={hideAreaPincodeDialog}
    >
      <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
        Add New Area Pincode
      </h5>
 
      {/* Render the AddingAreaPincode component */}
      <AddingAreaPincode
        showAreaPincodeDialog={showAreaPincodeDialog}
        hideAreaPincodeDialog={hideAreaPincodeDialog}
        handleAddSuccess={handleAddSuccess}
      />
 
      <Button label="Close" onClick={hideAreaPincodeDialog} />
    </Dialog>
  );
};
 
export default AddAreaPincodeMaster;
 
 
 